<template>
  <modal-template ref="modal" modal-size="sm" title="Upload de Arquivos" type-modal="upload_file_modal">
    <div class="modal-content__main">
      <d-form :validate="validateFiles">

        <d-form-row>
          <d-col class="form-group">
            <label for="fileInput" class="m-0 p-0">Selecionar Arquivos</label>
            <input
              type="file"
              id="fileInput"
              class="form-control"
              multiple
              @change="addFiles"
            >
          </d-col>
        </d-form-row>

        <div v-if="hasSelectedFiles">
          <label>Arquivos Selecionados</label>
          <d-list-group class="file-list">
            <d-list-group-item v-for="(file, index) in selectedFiles" :key="index" class="m-0 p-3">
              <d-form-row class="">
                <d-col cols="10">
                  <d-form-input
                    v-model="file.name"
                    type="text"
                    :placeholder="`Nome do arquivo ${index + 1}`"
                    class="form-control"
                    :state="hasFileError(index)"
                  />
                  <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
                  <small class="text-muted">{{ file.originalName }}</small>
                </d-col>
                <d-col cols="auto">
                  <d-button
                    type="button"
                    size="sm"
                    class="btn-danger ml-2 py-2"
                    @click="removeFile(index)"
                  >
                    <i class="fas fa-trash"></i>
                  </d-button>
                </d-col>
              </d-form-row>
            </d-list-group-item>
          </d-list-group>
        </div>

      </d-form>
    </div>
    <div slot="actions" class="modal-content__control">
      <d-button type="button" class="btn btn-sm btn-secondary mr-3" @click="cancel">Cancelar</d-button>
      <d-button
        type="button"
        class="btn btn-sm btn-primary"
        @click="save"
        :disabled="!hasSelectedFiles"
      >
        Salvar {{ hasSelectedFiles ? `(${selectedFilesCount})` : '' }}
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';
import Events from '_utils/events';
import CustomerService from '_services/rest/modules/customer';
import { _SAVE_FILE_SUCCESS_, _SAVE_CUSTOMER_SUCCESS_ } from '../CustomerModel';

export default {
  name: 'upload-customer-file',
  components: {
    ModalTemplate,
  },
  data() {
    return {
      customerId: this.$route.params.customerId ? parseInt(this.$route.params.customerId, 10) : null,
      selectedFiles: [],
      submitted: false,
    };
  },
  computed: {
    tempFiles() {
      const { tempFiles } = this.$store.state.customer;
      if (tempFiles && tempFiles.length > 0) {
        return tempFiles;
      }
      return [];
    },
    hasSelectedFiles() {
      return this.selectedFiles.length > 0;
    },
    selectedFilesCount() {
      return this.selectedFiles.length;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'setTempFiles',
      'clearTempFiles',
    ]),
    addFiles(event) {
      const newFiles = Array.from(event.target.files).map(this.formatInputFile);
      this.selectedFiles = [...this.selectedFiles, ...newFiles];
      event.target.value = '';
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    cancel() {
      this.resetSelectedFiles();
      this.setToggle({ type: 'upload_file_modal', bool: false });
    },
    resetSelectedFiles() {
      this.selectedFiles = [];
      this.submitted = false;
    },
    resetTempFiles() {
      this.clearTempFiles();
    },
    formatInputFile(file) {
      return {
        name: file.name.split('.')[0],
        originalName: file.name,
        file,
      };
    },
    prepareForUpload(file, id = null) {
      const fileData = {
        ...file,
        id: this.customerId || id,
      };

      return fileData;
    },
    uploadFiles(files) {
      const uploadPromises = files.map(file => {
        const fileToUpload = this.prepareForUpload(file);
        return CustomerService.uploadFile(fileToUpload);
      });

      return Promise.all(uploadPromises);
    },
    save() {
      if (!this.customerId) {
        this.saveTempFiles();
        return;
      }
      this.saveFilesToServer();
    },
    saveTempFiles() {
      this.submitted = true;

      if (this.validateFiles()) {
        const files = this.selectedFiles.map(file => this.prepareForUpload(file));
        this.setTempFiles([...this.tempFiles, ...files])
          .then(() => {
            this.activeAlert({
              message: `${this.selectedFilesCount} arquivo(s) adicionado(s) temporariamente`,
              theme: 'success',
            });
            this.resetSelectedFiles();
            this.cancel();
          });
        return;
      }
      this.activeAlert({
        message: 'Preencha os nomes obrigatórios dos arquivos',
        theme: 'danger',
      });
    },
    saveFilesToServer() {
      this.submitted = true;

      if (this.validateFiles()) {
        this.uploadFiles(this.selectedFiles)
          .then(() => {
            this.activeAlert({
              message: `${this.selectedFilesCount} arquivo(s) enviado(s) com sucesso`,
              theme: 'success',
            });
            Events.$emit(_SAVE_FILE_SUCCESS_);
            this.cancel();
          })
          .catch(error => {
            this.activeAlert({
              message: `Erro ao enviar arquivos: ${error.message} <br/> ${error.data}`,
              theme: 'danger',
            });
          });
        return;
      }
      this.activeAlert({
        message: 'Preencha os nomes obrigatórios dos arquivos',
        theme: 'danger',
      });
    },
    handleSaveCustomerSuccess(customer) {
      if (this.tempFiles.length === 0) return;
      this.customerId = customer.id;

      this.uploadFiles(this.tempFiles)
        .then(() => {
          Events.$emit(_SAVE_FILE_SUCCESS_);
          this.resetTempFiles();
        })
        .catch(error => {
          this.activeAlert({
            message: `Erro ao enviar arquivos do novo cliente: ${error.message} <br/> ${error.data}`,
            theme: 'danger',
          });
        });
    },
    validateFiles() {
      return this.selectedFiles.every(file => file.name && file.name.trim() !== '');
    },
    hasFileError(index) {
      const file = this.selectedFiles[index];
      if (this.submitted) {
        return (!file.name || file.name.trim() === '') ? 'invalid' : 'valid';
      }
      return null;
    },
  },
  mounted() {
    this.resetTempFiles();
    this.resetSelectedFiles();
    Events.$on(_SAVE_CUSTOMER_SUCCESS_, this.handleSaveCustomerSuccess);
  },
  beforeDestroy() {
    Events.$off(_SAVE_CUSTOMER_SUCCESS_, this.handleSaveCustomerSuccess);
  },
};
</script>

<style lang="scss" scoped>
.file-list {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
